// extracted by mini-css-extract-plugin
export var well = "ProgressBar-module--well--44SFs";
export var progress = "ProgressBar-module--progress--2Hqy_";
export var progressStarted = "ProgressBar-module--progress-started--3hIW-";
export var increaseprogress = "ProgressBar-module--increaseprogress--3vZ86";